document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const formEmbed = document.querySelector('shopify-forms-embed');
        if (!formEmbed) return;

        const shadow = formEmbed.shadowRoot;
        if (!shadow) return;

        // Create a <style> element
        const style = document.createElement('style');
        style.textContent = `
        ._textHeading_2aowh_35 {
            padding-top: 5rem;
            color: #232a4e !important;
        }
        ._textBody_2aowh_10._checkboxLegend_1hja3_20 {
            display: none !important;
        }
        `;

        // Append it to shadow root
        shadow.appendChild(style);

        formEmbed.setAttribute('active', 'true');
    }, 500)

}) 